import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/api';
import { useIsMobile } from '../hooks/useIsMobile';

const T = {
  bg: '#f2f2ee',
  border: '#e5e0d5',
  text: '#0A0A0A',
  muted: '#8b7d6b',
};
const SZ   = 'clamp(10px, 1vw, 16px)';
const FONT = "'Courier Prime Sans', 'Courier New', monospace";

const CONTACT = {
  name:  'Pierce Bancroft Townsend',
  email: 'hello@piercebtownsend.com',
  phone: '(512) 555-0000',
};

function Dot() {
  return <span style={{ display: 'inline-block', width: 5, height: 5, borderRadius: '50%', background: T.text, marginRight: 8, verticalAlign: 'middle', marginBottom: 2 }} />;
}

function BriefsTab() {
  const [briefs, setBriefs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.briefs.list()
      .then(setBriefs)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p style={{ fontSize: SZ, color: T.muted, letterSpacing: '0.06em' }}>Loading...</p>;
  if (briefs.length === 0) return <p style={{ fontSize: SZ, color: T.muted, letterSpacing: '0.06em' }}>No briefs yet — check back soon.</p>;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {briefs.map(brief => (
        <Link key={brief.id} to={`/portal/briefs/${brief.id}`} style={{ textDecoration: 'none' }}>
          <div
            style={{ padding: '24px 0', borderBottom: `1px solid ${T.border}`, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
            onMouseEnter={e => e.currentTarget.querySelector('.brief-title').style.color = T.muted}
            onMouseLeave={e => e.currentTarget.querySelector('.brief-title').style.color = T.text}
          >
            <div>
              <div className="brief-title" style={{ fontSize: SZ, color: T.text, letterSpacing: '0.06em', textTransform: 'uppercase', marginBottom: 6, transition: 'color 0.3s ease' }}>
                {brief.title}
              </div>
              <div style={{ fontSize: SZ, letterSpacing: '0.06em', color: T.muted, textTransform: 'uppercase' }}>
                Pre-Shoot Brief{brief.shoot_date ? ` · ${brief.shoot_date}` : ''}
              </div>
            </div>
            <span style={{ fontSize: SZ, letterSpacing: '0.06em', color: T.muted, textTransform: 'uppercase', flexShrink: 0, marginLeft: 24 }}>
              Open →
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}

function ContactTab() {
  return (
    <div style={{ paddingTop: 8 }}>
      {[
        { label: 'Name',  value: CONTACT.name  },
        { label: 'Email', value: CONTACT.email  },
        { label: 'Phone', value: CONTACT.phone  },
      ].map(({ label, value }) => (
        <div key={label} style={{ padding: '20px 0', borderBottom: `1px solid ${T.border}` }}>
          <div style={{ fontSize: SZ, letterSpacing: '0.06em', color: T.muted, textTransform: 'uppercase', marginBottom: 6 }}>{label}</div>
          <div style={{ fontSize: SZ, letterSpacing: '0.06em', color: T.text }}>{value}</div>
        </div>
      ))}
    </div>
  );
}

export default function ClientPortal() {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const [tab, setTab] = useState('briefs');

  return (
    <div style={{ minHeight: '100vh', background: T.bg }}>

      <nav style={{ backgroundColor: T.bg, borderBottom: `1px solid ${T.border}`, position: 'sticky', top: 0, zIndex: 50 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: isMobile ? '10px 24px' : '10px' }}>
          <a href="/" style={{ color: T.text, fontSize: SZ, letterSpacing: '0.06em', fontWeight: 400, textDecoration: 'none', textTransform: 'uppercase' }}>
            Pierce Bancroft Townsend
          </a>
          {user?.display_name && (
            <span style={{ fontSize: SZ, letterSpacing: '0.06em', color: T.muted, textTransform: 'uppercase' }}>
              {user.display_name}
            </span>
          )}
        </div>
      </nav>

      <div style={{ maxWidth: 620, margin: '0 auto', padding: '48px 24px' }}>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 28, marginBottom: 32, borderBottom: `1px solid ${T.border}`, paddingBottom: 16 }}>
          {[{ key: 'briefs', label: 'Briefs' }, { key: 'contact', label: 'Contact' }].map(n => (
            <button key={n.key} onClick={() => setTab(n.key)} style={{
              background: 'transparent', border: 'none', padding: 0,
              fontSize: SZ, letterSpacing: '0.06em', textTransform: 'uppercase',
              color: tab === n.key ? T.text : T.muted,
              cursor: 'pointer', fontFamily: FONT,
              display: 'flex', alignItems: 'center',
            }}>
              {tab === n.key && <Dot />}
              {n.label}
            </button>
          ))}
        </div>

        {tab === 'briefs'   && <BriefsTab />}
        {tab === 'contact'  && <ContactTab />}
      </div>
    </div>
  );
}
